import { faker } from '@faker-js/faker'
import { createPaymentList } from '../../mocks/generators/payments'
import { mockCustomers } from './mockCustomers'

faker.seed(42)
const customerRefs: { id: string; name: string; email: string }[] = mockCustomers.map((c) => ({
  id: c.id,
  name: c.name || '',
  email: c.email || '',
}))
export const mockPayments = createPaymentList(175, undefined, { customers: customerRefs })
